export default __webpack_public_path__ + "static/media/symbol_entryfish_inverse.249d5404.png";